import { render, staticRenderFns } from "./BaseSelectInput.vue?vue&type=template&id=08735189"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports